export enum PrescriptionRenewalModalStep {
  TERMS = 'TERMS',
  ORDER_FORM = 'ORDER_FORM',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE'
}

export interface Doctor {
  id: string;
  name: string;
}

export interface PrescriptionRenewalFormData {
  doctorId: string;
  description: string;
}

export enum PrescriptionRenewalStatusEnum {
  PENDING = 'PENDING',
  CONCLUDED = 'CONCLUDED',
  REJECTED = 'REJECTED'
}

export interface PrescriptionRenewal {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  description: string;
  doctor: {
    id: string;
  };
  eligibilitySchedule: {
    id: string;
  };
  rejectionReason?: string;
  resolvedAt?: Date;
  resolvedBy?: string;
  status: PrescriptionRenewalStatusEnum;
}
